export const LtiErrorLinks: { code: string; link: string }[] = [
  {
    code: "T801",
    link: "https://help.deltamath.com/lti-error-messages/#t801-0",
  },
  {
    code: "T802",
    link: "https://help.deltamath.com/lti-error-messages/#t802-1",
  },
  {
    code: "T805",
    link: "https://help.deltamath.com/lti-error-messages/#t805-2",
  },
  {
    code: "T806",
    link: "https://help.deltamath.com/lti-error-messages/#t806-2",
  },
  {
    code: "T807",
    link: "https://help.deltamath.com/lti-error-messages/#t807-3",
  },
  {
    code: "T812",
    link: "https://help.deltamath.com/lti-error-messages/#t812-4",
  },
  {
    code: "T814",
    link: "https://help.deltamath.com/lti-error-messages/#t814-5",
  },
  {
    code: "T815",
    link: "https://help.deltamath.com/lti-error-messages/#t815-6",
  },
  {
    code: "T816",
    link: "https://help.deltamath.com/lti-error-messages/#t816-7",
  },
  {
    code: "T818",
    link: "https://help.deltamath.com/lti-error-messages/#t818-8",
  },
  {
    code: "T819",
    link: "https://help.deltamath.com/lti-error-messages/#t819-9",
  },
];
